export const socialsData = {
    github: "https://github.com/pri65",
    
    linkedIn: "https://www.linkedin.com/in/priyankaso/",
    
    
  };